<template>
	<div class="app-view jobs-center-view jobs-center-view-manage-jobs">
		<header class="app-view__header">
			<h1 class="headline">Manage Jobs</h1>
		</header>

		<div class="jobs-center__filters-wrapper">
			<div>
				<quick-filters />
			</div>
			<div :class="['filter-actions', 'btn-index', {'open':filterOpenState}]">
				<job-filter />
				<job-search />
			</div>	
		</div>

		<main class="app-view__content">
			<div v-responsive:sila="['hidden-all', 'large', 'xlarge']">
				<jobs-center-grid/>
			</div>
			<div v-responsive:sila="['hidden-all', 'small', 'medium']">
				<jobs-center-cards/>
			</div>
		</main>


		<!-- wrap in case we need more stuff ... i knew it would come in handy, overflow! -->
		<div v-if="!mobile" class="fab-wrapper">
			<v-btn
				v-if="canCreateRequest"
				fab color="primary"
				class="create-job-btn"
				@click="startNewJobFlow">
				<v-icon>add</v-icon>
			</v-btn>
		</div>
		<create-job />
	</div>
</template>

<script>
	import { mapActions, mapGetters, mapState } from 'vuex'
	
	import { VUEX_JOB_CREATE_INIT } from '@/store/constants/jobs'
	import {
	    VUEX_USERS_GET_USERS_BY_ROLE_NO_PENDING,
        VUEX_USERS_GET_USERS_BY_ROLE_ACTIVE
	} from '@/store/constants/users'

    import { VUEX_ROUTING_EXIT_JOBS } from '@/store/constants/routing'

	import JobsCenterGrid from '@/components/ui/Jobs/Jobs_Center_Grid'
	import JobsCenterCards from '@/components/ui/Jobs/Jobs_Center_Cards'
	import CreateJob from '@/components/ui/Jobs/Create_Job.vue'

	import JobFilter from '@/components/ui/Jobs/Job_Filter.vue'
	import JobSearch from '@/components/ui/Jobs/Job_Search.vue'

    import QuickFilters from '@/components/ui/Jobs/Jobs_Quick_Filters.vue'

	export default {
		name: 'jobs-manage-view',

		components: {
			'jobs-center-grid'  	: JobsCenterGrid,
			'jobs-center-cards' 	: JobsCenterCards,
			'create-job'        	: CreateJob,
			'quick-filters'     	: QuickFilters,
			'job-filter'        	: JobFilter,
			'job-search'        	: JobSearch,
		},

		computed: {
			...mapState({
				mobile: state => state.mobile.mobile,
				filterOpenState: state => state.ui.jobFilterOverlay.openState,
			}),

			...mapGetters({
				currentUserHasPerm: 'currentUserHasPerm'
			}),

			canCreateRequest() {
				return this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_CREATE)
			},

		},

		/*beforeRouteEnter(to, from, next) {
			next( vm => {
				vm.$store.dispatch('VUEX_USERS_GET_USERS_BY_ROLE')
			})
		},*/

		mounted() {
			this.getUsersByRoleNoPending()
            this.getUsersByRoleActive()
		},

		methods: {
			...mapActions({
				startNewJobFlow: VUEX_JOB_CREATE_INIT,
                getUsersByRoleNoPending: VUEX_USERS_GET_USERS_BY_ROLE_NO_PENDING,
                getUsersByRoleActive: VUEX_USERS_GET_USERS_BY_ROLE_ACTIVE,
				saveExitState: VUEX_ROUTING_EXIT_JOBS
			}),

		},
		
		beforeRouteLeave(to, from, next){
			if (document.body.style.position == 'fixed'){
                document.body.style.position = ''
            }
			this.saveExitState()
			next()
        }
	}
</script>

<style>
.btn-index {
	z-index:1;
}
</style>


